/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseComponent, DamShare} from 'compob2b-libs';
import {NbCardModule, NbLayoutModule} from '@nebular/theme'
import {NgIf} from '@angular/common'
import {DamFilesModule} from '../files/dam-files.module'

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  standalone: true,
  imports: [
    NbLayoutModule,
    NbCardModule,
    NgIf,
    DamFilesModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShareComponent extends BaseComponent implements OnInit {
  shareSyncUid: string;
  title = '';
  loaded = false;
  route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.shareSyncUid = this.route.snapshot.paramMap.get('shareSyncUid');
    this.compoApiService.get<DamShare>('/dam/shared/' + this.shareSyncUid)
      .subscribe(response => {
        this.loaded = true;
        this.title = response.data?.header || 'Нет доступных элементов';
        this.cdr.detectChanges();
      });
  }

}
